var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-alarm-extra-details-chip',_vm._g({attrs:{"icon":_vm.preparedIcon,"color":_vm.preparedColor,"icon-color":_vm.iconColor}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }